import type { ReactNode } from "react";

import backgroundGray from "@/assets/background_gray.svg";

import PatternBackground from "./PatternBackground";

type AuthCardProps = {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  /** Override the pattern behind the card (defaults to the gray brand pattern). */
  background?: string;
  /** Squiggle decorator above the title, as used on the enrollment "¡Nos vemos!" page. */
  decorator?: string;
};

export default function AuthCard({
  title,
  subtitle,
  children,
  background = backgroundGray,
  decorator,
}: AuthCardProps) {
  return (
    <PatternBackground background={background}>
      <div className="w-full max-w-2xl rounded-[40px] border-2 border-ink bg-white px-6 py-10 shadow-sm sm:px-12 sm:py-14">
        {decorator && (
          <img
            src={decorator}
            alt=""
            aria-hidden
            className="mx-auto w-64 sm:w-80"
          />
        )}
        <h1
          className={`text-center font-sans text-4xl text-ink sm:text-5xl ${decorator ? "mt-6" : ""}`}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mx-auto mt-4 max-w-md text-center font-sans text-base font-light text-ink/70 sm:text-lg">
            {subtitle}
          </p>
        )}
        <div className="mt-8 sm:mt-10">{children}</div>
      </div>
    </PatternBackground>
  );
}
